import { reduce } from "lodash";

/**
 * Formata a resposta da API de justificativas, aplicando lógicas de exibição e cálculo de totais.
 * @param {Array} response Resposta original da API
 * @returns {Object} Objeto contendo os projetos formatados e os projetos para anexo
 */
export function formatJustificativasResponse(response) {
  const projetosAnexoComprobatorio = response.map((row) => ({
    id: row.projeto.agrupamento_id ? row.projeto.agrupamento_id : row.projeto.id,
    titulo: row.projeto.agrupamento_id
      ? row.projeto.agrupamento_titulo
      : row.projeto.titulo,
    agrupamento: row.projeto.agrupamento_id ? true : false,
  }));

  const projetos = response.map((row) => {
    if (row.colaboradores) {
      row.colaboradores = row.colaboradores.map((col) => ({
        ...col,
        cpf: !col.cpf || (col.cpf.length !== 11 && col.cpf.length !== 14) ? "" : col.cpf,
        projeto_id: row.projeto.agrupamento_id
          ? row.projeto.agrupamento_id
          : row.projeto.id,
      }));
    } else if (row.terceiros) {
      row.terceiros = row.terceiros.map((col) => ({
        ...col,
        cnpj: col.cnpj && col.cnpj.length > 0 ? col.cnpj : col.cpf,
        hasDuplicidades: false,
        isCnpj: col.cnpj && col.cnpj.length > 0,
        projeto_id: row.projeto.agrupamento_id
          ? row.projeto.agrupamento_id
          : row.projeto.id,
        terceiro_id: col.id, // Keep original ID for non-grouped
      }));
    } else if (row.materiais) {
      row.materiais = row.materiais.map((col) => ({
        ...col,
        projeto_id: row.projeto.agrupamento_id
          ? row.projeto.agrupamento_id
          : row.projeto.id,
      }));
    }

    return {
      ...row,
      total: reduce(
        row.colaboradores || row.terceiros || row.materiais || [],
        (rowA, rowB) => {
          rowA.quantidade += rowB.quantidade ? rowB.quantidade * 1 : 0;
          rowA.valor += rowB.valor ? rowB.valor * 1 : 0;
          rowA.horas += rowB.horas ? rowB.horas * 1 : 0;
          return rowA;
        },
        {
          nome: "Total",
          descricao: "Total",
          quantidade: 0,
          horas: 0,
          valor: 0,
        },
      ),
    };
  });

  return { projetos, projetosAnexoComprobatorio };
}

/**
 * Monta o payload para salvar justificativas de Colaboradores e Terceiros
 */
export function prepareSaveData(formData, tipoSelecionado, tipoEnum, servico) {
  const { justificativa_id, justificativa, id, projeto_id, funcao_projeto, agrupamento_key, formacao_li_descricao } = formData;
  const isColaboradores = tipoSelecionado === tipoEnum.COLABORADORES;

  const payload = {
    model_id: id,
    model_type: isColaboradores ? "funcionarios" : "terceiros",
    projeto_id: projeto_id,
    justificativa: justificativa,
    justificativa_id: justificativa_id,
    funcao_projeto: funcao_projeto,
    formacao_li_descricao: formacao_li_descricao,
    trabalho: servico,
  };

  // If it's a grouped terceiro, we send the agrupamento_key
  if (!isColaboradores && agrupamento_key) {
    payload.agrupamento_key = agrupamento_key;
    payload.terceiro_id = id; // Here id is null if grouped in service, but check logic
  }

  return payload;
}

/**
 * Monta o payload para salvar justificativas de Materiais LI
 */
export function prepareSaveDataMateriais(formData, servico, intervaloCompetencia) {
  const { justificativa, descricao, projeto_id, funcao_projeto, tipo } = formData;

  return {
    descricao: descricao,
    projeto_id: projeto_id,
    justificativa: justificativa,
    funcao_projeto: funcao_projeto,
    tipo: tipo,
    trabalho: servico,
    competenciaIni: intervaloCompetencia[0],
    competenciaFim: intervaloCompetencia[1],
  };
}
